import styled from 'styled-components';
import {MAIN_COLOR} from "../../../components/globalThemes";

const NewsTitle = styled.p`
    font-family: Roboto Condensed, serif;
    color: black;
    font-size: 22px;  
    font-weight: bold;
    margin-top: 30px;
    border-left: 22px solid ${MAIN_COLOR};
    line-height: 25px;
    padding-left: 10px;
    margin-bottom: 0;
`;

export default NewsTitle;
